module.exports = __webpack_public_path__ + "img/podium_1234.695c8808.jpg";